export const createPDFfromResponse = (data: any) => {
  let blob = new window.Blob([data], {
    type: "application/pdf",
  });
  return window.URL.createObjectURL(blob);
};
